import { VALIDATION_RULES } from '~shared/constants/validation-rules.constant';

import { IAdvancedFormConfig } from '../models/advanced-form.model';
import { CountryCode } from '~shared/constants/country-code.enum';

export const ADVANCED_FORM_BASE_CONFIG: IAdvancedFormConfig = {
  formSectionList: [],
  actionList: [],
  initialFormData: {},
  fieldsExtraOptions: {},
  formValidatorList: [],
  validationRules: VALIDATION_RULES,
};

export const COMMON_DISABLED_FIELDS = ['email', 'businessName', 'legalAddressCity', 'legalAddressCountry'];

export const COUNTRY_WISE_DISABLED_FIELDS_LIST = {
  [CountryCode.Germany]: COMMON_DISABLED_FIELDS,
  [CountryCode.Spain]: COMMON_DISABLED_FIELDS,
  [CountryCode.Italy]: [...COMMON_DISABLED_FIELDS, 'vatNumber'],
  [CountryCode.Portugal]: [...COMMON_DISABLED_FIELDS, 'vatNumber'],
  [CountryCode.Netherlands]: [
    ...COMMON_DISABLED_FIELDS,
    'kvkNumber',
    'legalAddressBuildingNumber',
    'legalAddressStreet',
    'legalAddressPostalCode',
  ],
  [CountryCode.France]: [
    ...COMMON_DISABLED_FIELDS,
    'sirenNumber',
    'legalAddressStreet',
    'legalAddressPostalCode',
  ],
};
